import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { BusinessIdeaViewer, BackToHome } from '../components';
import { BusinessIdea } from '../components/onboarding/onboarding.types';
import { useBusinessIdea } from '../hooks/useBusinessIdea';

const BusinessIdeaPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  // Try to get business idea from location state first (for direct navigation)
  // Otherwise, use the hook to fetch it
  const businessIdeaFromState = location.state?.businessIdea as BusinessIdea;
  const { businessIdea: businessIdeaFromHook } = useBusinessIdea();

  const businessIdea = businessIdeaFromState || businessIdeaFromHook;

  if (!businessIdea) {
    return (
      <div className="min-h-screen bg-background-dark">
        <BackToHome />
        <main className="p-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-background-surface/95 backdrop-blur-sm rounded-lg border border-gray-600 p-6">
              <p className="text-text-secondary">Business idea not found.</p>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-dark">
      <BackToHome />
      <main className="p-6">
        <div className="max-w-4xl mx-auto">
          {/* Business Idea Viewer */}
          <div className="bg-background-surface/95 backdrop-blur-sm rounded-lg border border-gray-600 overflow-hidden">
            <BusinessIdeaViewer businessIdea={businessIdea} readOnly={true} showActions={false} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default BusinessIdeaPage;
